export default __webpack_public_path__ + "static/media/controls-button.57618e5f.png";